export default __webpack_public_path__ + "static/media/esports-arena.0c4e1c92.png";